import { render, staticRenderFns } from "./log_Wheel.vue?vue&type=template&id=2190ec7c&"
import script from "./log_Wheel.vue?vue&type=script&lang=js&"
export * from "./log_Wheel.vue?vue&type=script&lang=js&"
import style0 from "./log_Wheel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports